export const dropBoolean = [
  { value: 'SIM', label: 'SIM' },
  { value: 'NAO', label: 'NÃO' },
];

export const dropStatusOrdemFabricacao = [
  { value: 'PENDENTE', label: 'PENDENTE' },
  { value: 'CONCLUIDO', label: 'CONCLUÍDO' },
];

export const dropTipoOfab = [
  { value: 'MONTAGEM', label: 'MONTAGEM' },
  { value: 'DESMONTAGEM', label: 'DESMONTAGEM' },
];

export const dropTipoRecurso = [
  { value: 'MAQUINA', label: 'MAQUINA' },
  { value: 'EQUIPAMENTO', label: 'EQUIPAMENTO' },
  { value: 'OPERADOR', label: 'OPERADOR' },
  { value: 'POSTO', label: 'POSTO' },
  { value: 'LINHA', label: 'LINHA' },
  { value: 'FERRAMENTA', label: 'FERRAMENTA' },
  { value: 'TERCEIRO', label: 'TERCEIRO' },
];

export const dropTipoCalendario = [
  { label: 'NORMAL', value: 'NORMAL' },
  { label: 'FERIADO', value: 'FERIADO' },
  { label: 'FERIAS', value: 'FERIAS' },
  { label: 'MANUTENCAO', value: 'MANUTENCAO' },
  { label: 'PARADA', value: 'PARADA' },
  { label: 'HORA_EXTRA', value: 'HORA_EXTRA' },
  { label: 'PRODUCAO', value: 'PRODUCAO' },
];
